@if (
  {
    schedules: schedules(),
    loading: loading(),
    formMode: formMode$ | async,
    schedule: schedule$ | async,
  };
  as data
) {
  @if (data.loading) {
    <app-loading [size]="'3x'"></app-loading>
  }
  @if (!data.loading && !data.formMode) {
    <div class="card-container schedules">
      @if (data.schedules?.length === 0) {
        <div class="no-schedules">
          {{
            "object-schdules.message.the-feed-dashboard-does-not-have-a-configured-schedule"
              | translate
          }}
        </div>
      }
      @for (schedule of data.schedules; track trackById($index, schedule)) {
        <app-schedule-card
          [schedule]="schedule"
          (editSchedule)="scheduleEdit($event)"
          (deleteSchedule)="delete($event)"
        ></app-schedule-card>
      }
      <app-object-card-placeholder
        [action]="create.bind(this)"
        [type]="'schedule'"
        class="card-placeholder"
        style="width: 100%"
      ></app-object-card-placeholder>
    </div>
  }
  @if (data.formMode) {
    <div class="editor-container">
      <app-export-settings
        #exportSettings
        [exportSchedule]="data.schedule"
        [formMode]="data.formMode"
        [objectId]="objectId"
        [objectClassId]="objectClassId"
        (saved)="cancel()"
      ></app-export-settings>
    </div>
  }
}
